import React from 'react';
import { useNewAptitudeTestScoreQuery } from './NewAptitudeQuizSlice';
import { Navigate } from 'react-router-dom';
import Loading from 'components/global/layout/Loading';
import NewCheckQuizStatus from './NewCheckQuizStatus';

const NewCheckAptitudeAttempt = () => {
  // changed this: useNewAptitudeAttemptQuery , according to new aptitude slice
  const { isLoading, isSuccess, isError, data } =
    useNewAptitudeTestScoreQuery();

  return (
    <div>
      {isError && <div> Error... </div>}
      {isLoading && (
        <div>
          <Loading />{' '}
        </div>
      )}
      {isSuccess && (
        <>
          {data?.timeTaken ? (
            <Navigate to='/quiz/new-aptitude/scorecard' replace />
          ) : (
            <NewCheckQuizStatus />
          )}
        </>
      )}
    </div>
  );
};

export default NewCheckAptitudeAttempt;
